import axios from "axios";
import { useEffect, useState } from "react";
import { orderBy } from "lodash";
import { IConfig, useConfig } from "../../../lib/config";
import { useKeycloakAuthz } from "../../../components/keycloak-provider";

export const useGetNotificationsWitbooking = ({ propertyTicker }: { propertyTicker: string }) => {
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(false);

  const configuration: IConfig = useConfig();
  const keycloak = useKeycloakAuthz()

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${configuration.notificationsWitbookingUrl}/hotel/${propertyTicker}`, {
          headers: {
            Authorization: keycloak.rpt,
          }
        });

        const notifications = orderBy(
          data.notifications.map((item: any) => ({
            ...item,
          })),
          ["createdAt"],
          ["desc"]
        );
        setData(notifications);
      } catch (error) {
        console.log("Error in notifications", error);
      }
      setLoading(false);
    };
    fetchData();
  }, [configuration.notificationsWitbookingUrl, propertyTicker, keycloak]);

  return { data, loading };
};
